import { c as _c } from "react/compiler-runtime";
import { useIntl } from '@onefootprint/hooks';
import { IcoDotSmall16 } from '@onefootprint/icons';
import type { Playbook } from '@onefootprint/request-types/dashboard';
import { Badge, CodeInline, Tooltip, Truncate } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
import Actions from './actions';
export type RowProps = {
  playbook: Playbook;
};
const Row = t0 => {
  const $ = _c(55);
  const {
    playbook
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "table.row"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("playbooks", t1);
  const {
    formatDateWithTime
  } = useIntl();
  const {
    publishedVersion: t2,
    activeDeployment: t3,
    hasProdOnboarding
  } = playbook;
  const {
    name,
    kind,
    key,
    status
  } = t2;
  const {
    createdAt
  } = t3;
  let t4;
  if ($[1] !== name) {
    t4 = <div className="min-w-0"><Truncate as="p" className="text-body-2">{name}</Truncate></div>;
    $[1] = name;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== hasProdOnboarding || $[4] !== t) {
    t5 = hasProdOnboarding && <Tooltip content={t(_temp)} side="right"><IcoDotSmall16 color="success" className="shrink-0" /></Tooltip>;
    $[3] = hasProdOnboarding;
    $[4] = t;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t4 || $[7] !== t5) {
    t6 = <td><div className="flex gap-1 items-center justify-between">{t4}{t5}</div></td>;
    $[6] = t4;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== kind || $[10] !== t) {
    t7 = kind === "kyc" && t(_temp2);
    $[9] = kind;
    $[10] = t;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== kind || $[13] !== t) {
    t8 = kind === "kyb" && t(_temp3);
    $[12] = kind;
    $[13] = t;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== kind || $[16] !== t) {
    t9 = kind === "auth" && t(_temp4);
    $[15] = kind;
    $[16] = t;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== kind || $[19] !== t) {
    t10 = kind === "document" && t(_temp5);
    $[18] = kind;
    $[19] = t;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== kind || $[22] !== t) {
    t11 = kind === "bank_linking" && t(_temp6);
    $[21] = kind;
    $[22] = t;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== t10 || $[25] !== t11 || $[26] !== t7 || $[27] !== t8 || $[28] !== t9) {
    t12 = <td>{t7}{t8}{t9}{t10}{t11}</td>;
    $[24] = t10;
    $[25] = t11;
    $[26] = t7;
    $[27] = t8;
    $[28] = t9;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  let t13;
  if ($[30] !== key) {
    t13 = <td><CodeInline>{key}</CodeInline></td>;
    $[30] = key;
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  let t14;
  if ($[32] !== status || $[33] !== t) {
    t14 = status === "enabled" && <Badge variant="success">{t(_temp7)}</Badge>;
    $[32] = status;
    $[33] = t;
    $[34] = t14;
  } else {
    t14 = $[34];
  }
  let t15;
  if ($[35] !== status || $[36] !== t) {
    t15 = status === "disabled" && <Badge variant="error">{t(_temp8)}</Badge>;
    $[35] = status;
    $[36] = t;
    $[37] = t15;
  } else {
    t15 = $[37];
  }
  let t16;
  if ($[38] !== t14 || $[39] !== t15) {
    t16 = <td>{t14}{t15}</td>;
    $[38] = t14;
    $[39] = t15;
    $[40] = t16;
  } else {
    t16 = $[40];
  }
  let t17;
  if ($[41] !== createdAt || $[42] !== formatDateWithTime) {
    t17 = formatDateWithTime(new Date(createdAt));
    $[41] = createdAt;
    $[42] = formatDateWithTime;
    $[43] = t17;
  } else {
    t17 = $[43];
  }
  let t18;
  if ($[44] !== t17) {
    t18 = <td>{t17}</td>;
    $[44] = t17;
    $[45] = t18;
  } else {
    t18 = $[45];
  }
  let t19;
  if ($[46] !== playbook.publishedVersion) {
    t19 = <td aria-label="actions"><Actions playbook={playbook.publishedVersion} /></td>;
    $[46] = playbook.publishedVersion;
    $[47] = t19;
  } else {
    t19 = $[47];
  }
  let t20;
  if ($[48] !== t12 || $[49] !== t13 || $[50] !== t16 || $[51] !== t18 || $[52] !== t19 || $[53] !== t6) {
    t20 = <>{t6}{t12}{t13}{t16}{t18}{t19}</>;
    $[48] = t12;
    $[49] = t13;
    $[50] = t16;
    $[51] = t18;
    $[52] = t19;
    $[53] = t6;
    $[54] = t20;
  } else {
    t20 = $[54];
  }
  return t20;
};
export default Row;
function _temp($) {
  return $.type.production;
}
function _temp2($_0) {
  return $_0.type.kyc;
}
function _temp3($_1) {
  return $_1.type.kyb;
}
function _temp4($_2) {
  return $_2.type.auth;
}
function _temp5($_3) {
  return $_3.type.document;
}
function _temp6($_4) {
  return $_4.type.bankLinking;
}
function _temp7($_5) {
  return $_5.status.enabled;
}
function _temp8($_6) {
  return $_6.status.disabled;
}